var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html, css } from "lit";
import { property, state } from "lit/decorators.js";
import { computePosition, shift, flip } from "@floating-ui/dom";
export class QboMenu extends LitElement {
    constructor() {
        super(...arguments);
        // Define the placement property with type `string`
        this.placement = "bottom-start";
        this.type = "dropdown";
        this.target = null;
        // Internal state to control menu visibility
        this.isOpen = false;
        this.middleware = [flip(), shift()];
        this.handleMenuOpen = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const customEvent = event;
            if (customEvent.detail.menu !== this && this.isOpen) {
                this.closeMenu();
            }
        };
        this.handleOutsideClick = (event) => {
            const target = event.target;
            const path = event.composedPath();
            if (!path.includes(this)) {
                this.closeMenu();
            }
        };
        this.showContextMenu = (event) => {
            const clickEvent = event;
            event.preventDefault();
            event.stopPropagation();
            this.isOpen = true;
            this.menuContainer.classList.toggle("open", this.isOpen);
            const source = {
                getBoundingClientRect: () => ({
                    x: clickEvent.clientX,
                    y: clickEvent.clientY,
                    width: 0,
                    height: 0,
                    top: clickEvent.clientY,
                    left: clickEvent.clientX,
                    right: clickEvent.clientX,
                    bottom: clickEvent.clientY,
                }),
            };
            this.updateMenuPosition(source);
        };
        this.toggleMenu = (event) => {
            //event.preventDefault();
            //event.stopPropagation();
            const target = event.target;
            const path = event.composedPath();
            if (!path.includes(this.triggerButton) || path.includes(this.menuContainer))
                return;
            this.isOpen = !this.isOpen;
            this.menuContainer.classList.toggle("open", this.isOpen);
            if (this.isOpen) {
                this.updateMenuPosition(this.triggerButton);
                document.dispatchEvent(new CustomEvent("qbo-menu-open", {
                    bubbles: true,
                    composed: true,
                    detail: { menu: this },
                }));
            }
        };
    }
    static { this.styles = css ``; }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("click", this.handleOutsideClick);
        // document.addEventListener("qbo-menu-open", this.handleMenuOpen);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("click", this.handleOutsideClick);
        // document.removeEventListener("qbo-menu-open", this.handleMenuOpen);
        if (this.type === "context")
            this.triggerButton.removeEventListener("contextmenu", this.showContextMenu);
        else
            this.triggerButton.removeEventListener("click", this.toggleMenu);
    }
    firstUpdated(changes) {
        super.firstUpdated(changes);
        this.triggerButton =
            this.querySelector("*[data-trigger]") ||
                this.querySelector("button") ||
                this.parentElement;
        this.menuContainer =
            this.querySelector("*[data-content]") ||
                this.querySelector("aside") ||
                this.querySelector("menu");
        if (this.type === "context") {
            if (this.target) {
                this.triggerButton =
                    this.closest(this.target) ||
                        (() => {
                            const rootNode = this.getRootNode();
                            if (rootNode instanceof ShadowRoot ||
                                rootNode instanceof Document) {
                                return rootNode.querySelector(this.target);
                            }
                            return null;
                        })() ||
                        document.querySelector(this.target) ||
                        document;
            }
            this.triggerButton.addEventListener("contextmenu", this.showContextMenu);
        }
        else {
            if (this.triggerButton != null)
                this.triggerButton.addEventListener("click", this.toggleMenu);
        }
    }
    closeMenu() {
        this.isOpen = false;
        this.menuContainer.classList.remove("open");
    }
    async updateMenuPosition(source) {
        console.log(source, typeof source);
        const { x, y } = await computePosition(source, this.menuContainer, {
            placement: this.placement,
            middleware: this.middleware,
            strategy: 'fixed'
        });
        Object.assign(this.menuContainer.style, {
            left: `${x}px`,
            top: `${y}px`,
        });
    }
    render() {
        return html `<slot></slot>`;
    }
}
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], QboMenu.prototype, "placement", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboMenu.prototype, "type", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboMenu.prototype, "target", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], QboMenu.prototype, "isOpen", void 0);
if (!customElements.get("qbo-menu"))
    customElements.define("qbo-menu", QboMenu);
